module.exports = __webpack_public_path__ + "static/media/la-brands-400.9769d0a6.svg";